import { ThemeUIStyleObject } from "theme-ui";

export const downloadStyle: ThemeUIStyleObject = {
  width: "full",
  maxWidth: "620px",
  maxHeight: "full",
  px: 0,
  color: "currentColor",
  margin: "auto",
};

export const downloadAspectStyles: ThemeUIStyleObject = {
  bg: "downloadGray",
  maxHeight: "full",
};

export const downloadImgStyle: ThemeUIStyleObject = {
  width: "100%",
};
export const downloadTextBoxStyle: ThemeUIStyleObject = {
  py: [4, 6],
  display: [null, "flex"],
  justifyContent: [null, "center"],
  alignItems: "center",
  flexDirection: ["column", "row"],
};
export const downloadHeadingTextStyle: ThemeUIStyleObject = {
  fontSize: ["paragraphSmall", "paragraphMedium"],
  my: [null, 0],
};
export const downloadDescriptionTextStyle: ThemeUIStyleObject = {
  fontSize: ["paragraphSmall", "paragraphMedium"],
  my: [null, 0],
};
export const downloadButtonStyle: ThemeUIStyleObject = {
  textDecoration: "none",
  width: ["full", "auto", "auto"],
  // marginLeft: [null, "auto"],
};
